import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BillingClient } from 'network/httpClients/BillingClient/BillingClient';
import { MUTATION_KEYS } from 'network/mutations/consts';
import { QUERY_KEYS } from 'network/queries/consts';

/**
 * Reverse a paid-cohort Move parked PAYMENT_ACTION_REQUIRED (off-session charge
 * needs 3DS), on the user's confirmation.
 *
 * Calls POST /billing/v1/conversions/move/reverse (no body). The BE cancels the
 * legacy sub, refunds the unused time, stamps the account self-serve, and returns
 * `reversed`. The caller then hands off to a standard self-serve checkout (3DS
 * runs on Stripe's page). On success we invalidate account-info + quota so the UI
 * reflects the now self-serve, sub-less account.
 * @returns the mutation; call `.mutate()` when the user confirms the reversal.
 */
export const useReverseMove = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.REVERSE_MOVE],
    mutationFn: () => BillingClient.reverseMove(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.BILLING_ACCOUNT_INFO],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.BILLING_QUOTA_BALANCE],
      });
    },
  });
};
